import { render, staticRenderFns } from "./dragDropTop.vue?vue&type=template&id=80ace334&scoped=true"
import script from "./dragDropTop.vue?vue&type=script&lang=js"
export * from "./dragDropTop.vue?vue&type=script&lang=js"
import style0 from "./dragDropTop.vue?vue&type=style&index=0&id=80ace334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ace334",
  null
  
)

export default component.exports